export const ADD_CONTENT_TABS = [
  { label: 'Paste URL', value: 'article' },
  { label: 'Upload File', value: 'file' },
];
